/**
 * @flow
 * */
import React from 'react';

import { RISK_WEEKLY_MODULE_PATH, RISK_WEEKLY_CONFIG_PATH, views } from './settings';

const RiskWeeklyReportPage = React.lazy(() => import('./views/pages/RiskWeeklyReport'));
const RiskWeeklyConfigurationPage = React.lazy(
  () => import('./views/pages/RiskWeeklyConfiguration')
);

type Route = {
  path: string,
  name: string,
  exact: boolean,
  page: Function
};

/**
 * Risk Weekly Report is a standalone feature, not part of SRMT: it spans SRMT, CRMT and GRMT
 * alert data, so it sits at its own top-level path rather than inside one product's tree.
 *
 * The :view segment is reserved for the views of the original report; they all render through the
 * same page shell.
 *
 * It is enumerated rather than left open, and that is load-bearing rather than tidiness. Module
 * routes are NOT rendered through a Switch that can see them — AppContainer nests them inside
 * Suspense and a couple of divs, so the Switch matches its one pathless child and every route
 * that matches the URL renders, stacked. An open `/:view` therefore matches `configuration` too
 * and draws the whole report underneath the configuration page. Declaration order cannot fix
 * that; only not matching can.
 */
const reportViews = Object.values(views).join('|');

const ROUTES: Array<Route> = [
  {
    path: `/${RISK_WEEKLY_MODULE_PATH}`,
    name: 'Risk Weekly Report',
    exact: true,
    page: RiskWeeklyReportPage
  },
  {
    path: `/${RISK_WEEKLY_MODULE_PATH}/${RISK_WEEKLY_CONFIG_PATH}`,
    name: 'Risk Weekly Configuration',
    exact: true,
    page: RiskWeeklyConfigurationPage
  },
  {
    path: `/${RISK_WEEKLY_MODULE_PATH}/:view(${reportViews})`,
    name: 'Risk Weekly Report',
    exact: true,
    page: RiskWeeklyReportPage
  }
];

export default ROUTES;
